import React, {useContext, useEffect, useRef, useState} from "react"
import ReactPlayer from "react-player";
import {navigate} from "gatsby";
import mobileInterface from "../../services/mobile_interface";
import Duration from "./duration";
import VolumnControl from "./volumnControl";
import Scrubber from "./scrubber";
import {useStickyState} from "../../hooks/useStickyState";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import Replay10Icon from '@material-ui/icons/Replay10';
import {AppBar, createStyles, IconButton, Theme} from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import {createMuiTheme, makeStyles} from "@material-ui/core/styles";
import SkipNextIcon from '@material-ui/icons/SkipNext';
import userService from "../../services/user";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SettingsIcon from '@material-ui/icons/Settings';
import {Video} from "../../models/video";
import VideoModal from "../videoModal";
import PlayButtonOverlay from "./playButtonOverlay";
import Hls from "hls.js";
import {isIOS, isMobile} from "react-device-detect";
import ClosedCaptionIcon from "@material-ui/icons/ClosedCaption";
import {ToggleButton, ToggleButtonGroup} from "@material-ui/lab";
import ClosedCaptionButton from "./closedCaptionButton";
import alertService from "../../services/alert";
import {Alert, AlertType} from "../../models/alert";
import _ from 'lodash'
import {GlobalDispatchContext, GlobalStateContext} from "../../context/GlobalContextProvider";


type VideoPlayerProps = {
    video: Video,
    videoURL: string,
    title: string,
    onEnded?: () => {},
    onReady?: any,
    handleProgress?: () => {},
    onSkip?: () => {},
    onVolumeChange: (number: number) => {},
    volume: number,
    showControls: boolean,
    startTime: number,
    playing: boolean,
    enableScrubbing:boolean //can be used to override scrubbing access checks
}
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        appBar: {
            top: 'auto',
            bottom: 0,
        },

    }),
);
declare global {
    interface Window { changeVideoUrl: any; }
}
export default function VideoPlayer(props: VideoPlayerProps) {
    const [quality, setQuality] = useStickyState(-1, 'quality');
    //const [levels, setLevels] = useStickyState(, 'quality');
    const globalState = useContext(GlobalStateContext);
    const globalDispatch = useContext(GlobalDispatchContext);

    let defaultVideoUrl = () => {
        let videoUrl = props.videoURL;
        // if(typeof props.video != "undefined"
        //     && typeof props.video.versions != "undefined"
        //     && typeof props.video.versions['hls'] != "undefined" ){
        //         videoUrl = props.video.versions['hls']
        // }
        return videoUrl;
    }
    const [qualityLevels, setLevels] = useState([])
    const [showClosedCaptions, setShowClosedCaptions] = useStickyState(false)
    const [state, setState] = useState({
        url: defaultVideoUrl(),
        video: props.video,
        pip: false,
        playing: props.playing,
        controls: false,
        light: false,
        muted: false,
        played: 0,
        loaded: 0,
        duration: 0,
        playbackRate: 1.0,
        loop: false,
        seeking: false,
        hadSeeked: false,
        justTracked: false,
        isReady: false,
        textTracks: []

    });
    const [volume, setVolume] = useStickyState(props.volume, 'volume');
    const [hideControls, setHideControls] = useState(false)
    const [enableScrub, setEnableScrub] = useState(props.enableScrubbing);
    let videoPlayer = React.createRef<ReactPlayer>();
    let showLightPlayer = false;
    useEffect(() => {
        //mobileInterface.PostToVideoHandler(state.url);
        mobileInterface.PostToMobileInterfaceHandler('videoHandler', 'changeVideoUrl', state.url);
        console.log(state.video);
    }, []);


    useEffect(()=>{
        const duration = 2000;
        let timeout;
        function mouseMoveListener () {
            setHideControls(false)
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                setHideControls(true)

            }, duration)
        }

        document.addEventListener('mousemove', mouseMoveListener);
        return function cleanUp () {
            clearTimeout(timeout);
            document.removeEventListener('mousemove', mouseMoveListener)
        }
    },[])

    const play = () => {
        let newState = {...state}
        newState.playing = true;
        setState(newState)
    }

    const changeVideoUrl = (newUrl: string) => {
        console.log("changeVideoUrl()");
        console.log(newUrl);
        let newState = {...state};
        newState.url = newUrl;
        setState(newState);
    }
    if (typeof window !== `undefined`) {
        window.changeVideoUrl = changeVideoUrl;
    }

    //  handle any exceptions including the user is blocking auto play of videos

    const onError = (e) => {
        showLightPlayer = true;
        console.log("error playing video: " + e);
        //forceUpdate();
    }

    const onEnded = () => {
        if(props.onEnded) {
            props.onEnded();
        }
    };

    const handleReady = (player) => {
        videoPlayer = player;
        const internalPlayer = player.getInternalPlayer();
        globalDispatch({type:"SET_VIDEO", videoRef: internalPlayer});

        console.log("*****READY******");
        // internalPlayer.onvolumechange = event => {
        //     handleVolumeChange(event.target.volume)
        // }
        let newState = {...state};
        newState.isReady = true;
        newState.textTracks = internalPlayer.textTracks;
        if(showClosedCaptions && newState.textTracks.length > 0) {
            // @ts-ignore
            newState.textTracks[0].mode = 'showing';
        }
        setState(newState);

        if (props.onReady) {
            props.onReady(state, internalPlayer, ref);
        }
        //updates levels options
        if(player != null && player.getInternalPlayer('hls') != null) {
            console.log(player.getInternalPlayer('hls').levels)
            //TODO set the available levels
            console.log(player.getInternalPlayer('hls').currentLevel);
            setLevels(player.getInternalPlayer('hls').levels.sort((a,b) => b.height-a.height))
        }

    }

    const handleSkip = () => {
        if (props.onSkip) props.onSkip();
    }

    const ref = player => {
        videoPlayer = player
    }

    const handlePlayPause = () => {
        let newState = {...state}
        newState.playing = !state.playing;
        setState(newState)
        console.log("width", globalState.videoRef.videoWidth);
        console.log("height", globalState.videoRef.videoHeight);
    }

    const rewindVideo = (seconds: number) => {
        if(typeof videoPlayer.getInternalPlayer() != "undefined") {
            videoPlayer.getInternalPlayer().currentTime = videoPlayer.getInternalPlayer().currentTime - seconds;
        }
    }


    const handleVolumeChange = newVolume => {
        console.log(newVolume);
        setVolume(newVolume);
    }


    const handleToggleMuted = () => {
        let newState = {...state}
        newState.muted = !state.muted;
        setState(newState)
    }


    const handlePlay = () => {
        console.log('onPlay')
        let newState = {...state}
        newState.playing = true;
        setState(newState)
    }


    const handlePause = () => {
        console.log('onPause')
        let newState = {...state}
        newState.playing = false;
        setState(newState)
    }


    const handleSeekChange = e => {
        console.log("seekChange: " + (parseFloat(e) / 100) * state.duration, parseFloat(e), state.duration);
        //setState({ played: parseFloat(e) })
        //if they try to scroll all the way to the end force the last few seconds to address bug with showing choices
        if((parseFloat(e) / 100) * state.duration > state.duration - 1){
            videoPlayer.seekTo((parseFloat(e) / 100) * state.duration - 1);
        } else {
            videoPlayer.seekTo((parseFloat(e) / 100) * state.duration);
        }
    }

    const handleProgress = s => {
        // We only want to update time slider if we are not currently seeking
        if (!state.seeking) {
            if(typeof props.handleProgress != "undefined") props.handleProgress(s);
            let newState = {...state, ...s}
            newState.justTracked = true;
            setState(newState)
        }
    }

    const handleEnded = () => {
        console.log('onEnded')
        //setState({ playing: state.loop })
    }

    const handleDuration = (duration) => {
        let newState = {...state};
        newState.duration = duration;
        setState(newState)
    }

    const handleClickFullscreen = () => {
        //screenfull.request(findDOMNode(videoPlayer))
    }

    const toggleCC = () => {

        let newState = {...state};
        if(showClosedCaptions) { //TODO find out why getInternalPlayer doesn't work here
            newState.textTracks[0].mode = 'disabled';
        } else {
            newState.textTracks[0].mode = 'showing';
        }
        setState(newState)
        setShowClosedCaptions(!showClosedCaptions);

    }
    const handleQualityChange = (event) => {
        setQuality(event.target.value);
        if(typeof videoPlayer.getInternalPlayer('hls') == "undefined") {
           console.log("No HLS Player")
        } else {
            //changeVideoUrl(videoPlayer.getInternalPlayer('hls').levels[event.target.value].url[0])
            videoPlayer.getInternalPlayer('hls').currentLevel  = event.target.value;
            console.log(videoPlayer.getInternalPlayer('hls').currentLevel)
        }
    }

    const levelsMap = qualityLevels.map((value, index) => {

            return (<MenuItem value={index} key={index + value.height}>{value.height}p</MenuItem>)

    })

    const nextButton = (userService.currentUser?.jessicas_room || userService.currentUser?.is_admin) && typeof props.onSkip != "undefined"
                    ?
                        <IconButton size={'small'} color={"secondary"} aria-label="Next" onClick={handleSkip}>
                            <SkipNextIcon />
                        </IconButton>
                    : null;

    const qualityMenuItems = (Object.keys(qualityLevels).length > 0)
                            ? <FormControl className={'iconSelect'}>
                                    <Select
                                        labelId="quality-level-select-label"
                                        id="quality-level-select"
                                        value={quality}
                                        onChange={handleQualityChange}
                                        IconComponent = {SettingsIcon}
                                        renderValue={()=>{return null}} //show now value
                                    >
                                        {levelsMap}
                                        <MenuItem value={-1}>Auto</MenuItem>
                                    </Select>
                                </FormControl>
                            : null;




    const classes = useStyles();

    function handleError(e: any, data: any, hlsInstance, hlsGlobal) {
        console.log("handleError", e, data, hlsInstance, hlsGlobal);
        if (typeof data != "undefined" && data.fatal && typeof hlsInstance != "undefined") {
            switch(data.type) {
                case Hls.ErrorTypes.NETWORK_ERROR:
                    // try to recover network error
                    console.log("fatal network error encountered, try to recover");
                    hlsInstance.startLoad();
                    break;
                case Hls.ErrorTypes.MEDIA_ERROR:
                    console.log("fatal media error encountered, try to recover");
                    hlsInstance.recoverMediaError();
                    break;
                default:
                    // cannot recover
                    hlsInstance.destroy();
                    break;
            }
        }

        if (typeof data != "undefined" && data.type == "otherError" && data.event == "hlsFragLoaded" && typeof hlsInstance != "undefined") {
            console.log("Handle hlsFragLoaded error");
            //TODO - figure out why this error is not recovering. hacky fix below
            //location.reload();
            //hlsInstance.destroy();
            //changeVideoUrl(state.video.src); //fallback to the mp4
        }
    }
    //doesn't work for touch
    const trackClick = (e) => {

        if(e.detail === 3) {
            console.log(e);
            setEnableScrub(true);
            console.log("scrubbing enabled");
        }
    }

    let _delayedClick;
    let clickedOnce;
    const handleClick = (e) => {
        if (!_delayedClick) {
            _delayedClick = _.debounce(doClick, 500);
        }
        if (clickedOnce) {
            _delayedClick.cancel();
            clickedOnce = false;
            setEnableScrub(true);
            console.log("scrubbing enabled");
        } else {
            _delayedClick(e);
            clickedOnce = true;
        }
    }

    const doClick = (e) => {
        clickedOnce = undefined;
        console.log('single click');
    }

    return (
        <div
            className='player-wrapper'
        >
            <ReactPlayer
                key={state.url}
                ref={ref}
                url={state.url}
                className={`react-player `}
                width='100%'
                height="100%"
                pip={state.pip}
                playing={state.playing}
                controls={false}
                playsinline={true}
                light={state.light}
                loop={state.loop}
                playbackRate={state.playbackRate}
                volume={typeof volume != 'undefined' ? volume /100 : 0.9}
                muted={state.muted}
                onReady={(player) => handleReady(player)}
                onStart={() => console.log('onStart')}
                onPlay={handlePlay}
                onPause={handlePause}
                onBuffer={() => console.log('onBuffer')}
                onSeek={e => console.log('onSeek', e)}
                onEnded={onEnded}
                onError={(e,data, hlsInstance, hlsGlobal) => handleError(e, data, hlsInstance, hlsGlobal)}
                onProgress={handleProgress}
                onDuration={handleDuration}
                config={ {
                    file: {
                        attributes: {
                            crossOrigin: 'true'
                        },
                        tracks: state.video.tracks,
                        hlsOptions: {
                            startLevel: quality,
                            "debug": process.env.ENV == "production" ? false : true,
                            "enableWorker": true
                        }
                    }
                }}
            />
            {/*<button style={{position:"absolute", zIndex:100, top: 0}}>RESUME</button>*/}
            {
                props.showControls ? <AppBar position="absolute" color="transparent" className={classes.appBar}>
                                        <Toolbar className={"customControls"  + (hideControls && state.playing ? " hide-video-controls":"")}>
                                            {!isIOS ? <VolumnControl
                                                onChange={handleVolumeChange}
                                                value={volume}
                                            />: null}
                                            <IconButton
                                                size={'small'}
                                                color={"secondary"}
                                                aria-label={state.playing ? 'Pause' : 'Play'}
                                                onClick={handlePlayPause}>
                                                {state.playing ? <PauseIcon/> : <PlayArrowIcon/> }
                                            </IconButton >
                                            <IconButton
                                                size={'small'}
                                                color={"secondary"}
                                                aria-label={"Rewind 10 seconds"}
                                                onClick={() => rewindVideo(10)}
                                            >
                                                <Replay10Icon color={"secondary"} />
                                            </IconButton >
                                            <Duration className='duration' seconds={state.duration * state.played}/>
                                            <Scrubber
                                                onChange={handleSeekChange}
                                                value={state.played * 100}
                                                videoState={state}
                                                enableScrubbing={enableScrub}
                                            />
                                            <Duration className='duration' seconds={state.duration}/>

                                            {nextButton}

                                            {qualityMenuItems}
                                            <a style={{
                                                "position":"fixed",
                                                top:0,
                                                right:0,
                                                width:"100px",
                                                height:"100px"}
                                            } onClick={(e)=> handleClick(e)}
                                            ></a>
                                            <ClosedCaptionButton onClick={state.textTracks.length > 0 ? toggleCC:()=>console.log("NO Text Tracks")} active={showClosedCaptions} disabled={state.textTracks.length <= 0} />

                                        </Toolbar>
                                    </AppBar>
                : null
            }


        </div>
    )

}